const PropTypes = require("prop-types");
// @ vendors
const React = require("react");
// @ commons
const { formatText } = require("core/i18n").i18n;
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");
// @ constants
const biocatch = require("constants/biocatch");

const RemoveBeneficiarySuccess = props => {
    const { beneficiaryAlias, beneficiaryName } = props;
    const title = formatText(
        "transfersAgenda-removeBeneficiarySuccessScreenTitle",
        [beneficiaryName, beneficiaryAlias]
    );
    const buttonLabel = formatText(
        "transfersAgenda-removeBeneficiarySuccessScreenButton"
    ).toUpperCase();
    const button = {
        label: buttonLabel,
        url: "/myprofile/transfers/agenda"
    };

    changeBiocatchContext(biocatch.SUCCESSFUL_OPERATION);

    return <WizardSuccess successMessage={title} mainButton={button} />;
};

RemoveBeneficiarySuccess.propTypes = {
    beneficiaryAlias: PropTypes.string,
    beneficiaryName: PropTypes.string
};

module.exports = RemoveBeneficiarySuccess;
